export default function(array) {
  return [...new Set(array)]
}
